import React, { useEffect } from 'react';
import { ModuleBridge, TopActionBar, Button, Flex } from '../components';

export const RecoveryApplianceSetup = () => {
    useEffect(() => {
        return () => {
            if (window?.clearAllIntervals) {
                window?.clearAllIntervals();
            }
        };
    }, []);

    return (
        <>
            <TopActionBar>
                <Flex gap="small">
                    <Button type="primary" onClick={() => window.setupBackupAppliance()}>
                        Setup New Recovery Appliance
                    </Button>
                </Flex>
            </TopActionBar>
            <div id="recovery_appliance_container"></div>
            <ModuleBridge moduleId="recovery_appliances_setup_module" />
        </>
    );
};
